import * as React from 'react';
import {FunctionComponent} from 'react';
import {VictoryAxis, VictoryBar, VictoryChart} from 'victory';

interface OwnProps {
    axis?: {
        x?: Array<{
            value: number;
            label: string;
        }>;
        y?: Array<{
            value: number;
            label: string;
        }>;
    };
    values: Array<{x: number; y: number}>;
}

const styles = {
    line: {
        data: {
            stroke: '#3ac4e7',
            fill: '#3ac4e7',
            strokeWidth: 0,
        },
    },
    axis: {
        axis: {
            stroke: 'rgba(0, 0, 0, 0.1)',
        },
        grid: {
            stroke: 'rgba(0, 0, 0, 0.1)',
            strokeWidth: 1,
            strokeDasharray: 4,
        },
        tickLabels: {
            fill: '#000',
        },
    },
};

export const BarChart: FunctionComponent<OwnProps> = ({axis, values}) => {
    return (
        <VictoryChart>
            {axis?.x ? (
                <VictoryAxis
                    fixLabelOverlap
                    style={styles.axis}
                    tickValues={axis.x.map((tick) => tick.value)}
                    tickFormat={(value) => {
                        return axis?.x?.find((tick) => tick.value === value)?.label ?? '';
                    }}
                />
            ) : (
                <VictoryAxis
                    style={{
                        axis: {stroke: 'transparent'},
                        ticks: {stroke: 'transparent'},
                        tickLabels: {fill: 'transparent'},
                    }}
                />
            )}
            {axis?.y ? (
                <VictoryAxis
                    style={styles.axis}
                    dependentAxis
                    fixLabelOverlap
                    orientation="left"
                    tickValues={axis.y.map((tick) => tick.value)}
                    tickFormat={(value) => {
                        return axis?.y?.find((tick) => tick.value === value)?.label ?? '';
                    }}
                />
            ) : (
                <VictoryAxis
                    style={{
                        axis: {stroke: 'transparent'},
                        ticks: {stroke: 'transparent'},
                        tickLabels: {fill: 'transparent'},
                    }}
                />
            )}
            <VictoryBar style={styles.line} data={values} />
        </VictoryChart>
    );
};
